import type { ZodInfer } from '@mntn-dev/utility-types'

import { BillingProfileIdSchema } from '../unique-id.models.ts'

export const FinanceEntityIdSchema = BillingProfileIdSchema

export type FinanceEntityId = ZodInfer<typeof FinanceEntityIdSchema>

export const FinanceEntityId = (id: string): FinanceEntityId => {
  return FinanceEntityIdSchema.parse(id)
}
